__turbopack_context__.v({
  "background": "SolaIconBadge-module__OdrYCq__background",
  "gradientSnakeSlide": "SolaIconBadge-module__OdrYCq__gradientSnakeSlide",
  "inner": "SolaIconBadge-module__OdrYCq__inner",
  "ring": "SolaIconBadge-module__OdrYCq__ring",
});
